

$( document ).ready(function() {
    $('.custom-mosaic .title-tabs .tab-title:first-child').addClass('gm-active');
    $('.custom-mosaic .title-tabs .tab-title').on( 'click', function() {
        var index_handle = $(this).index()+1;
        $('.custom-mosaic .title-tabs .tab-title').removeClass('gm-active');
        $(this).addClass('gm-active');
        $('.mosaic-card-container').hide();
        $('.mosaic-card-container.index-'+ index_handle).css('display','inherit');
    });
    $('.arrow-buttons .prev-button').on('click', function() {
        var $activeTab = $('.gm-active');
        $activeTab.prev().click();
    });
    $('.arrow-buttons .next-button').on('click', function() {
        var $activeTab = $('.gm-active');
        $activeTab.next().click();
    });
});